import { configureStore } from '@reduxjs/toolkit';
import appReducer from '../slices/index';

const reducer = {
  app: appReducer,
};

const store = configureStore({
  reducer,
  devTools: process.env.NODE_ENV === 'development',
});

export default store;
